// The docked panel takes this width when there is room for it beside the page.
export const DOCKED_PANEL_WIDTH = 420;

// The narrowest the panel gets, docked or floating.
export const MIN_PANEL_WIDTH = 320;

export const MIN_PAGE_WIDTH_BESIDE_DOCKED_PANEL = 762;

// The docked panel narrows to fit the room left beside the page, so the page keeps its
// minimum width. Below the panel's minimum there is no room to dock, and this is null.
const dockedPanelWidth = (widthBesideScrollbar: number, sidebarWidth: number): number | null => {
  const room = widthBesideScrollbar - sidebarWidth - MIN_PAGE_WIDTH_BESIDE_DOCKED_PANEL;
  if (room < MIN_PANEL_WIDTH) return null;
  return Math.min(room, DOCKED_PANEL_WIDTH);
};

export default dockedPanelWidth;
